'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = require('lodash');

var _paymentUtil = require('../../../../../common/payment/paymentUtil');

var _currencyUtil = require('../../../../../common/payment/currencyUtil');

var _Spinner = require('../../../../components/loaders/Spinner');

var _Spinner2 = _interopRequireDefault(_Spinner);

require('./PaymentSummary.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PaymentAmount = function PaymentAmount(_ref) {
    var coupon = _ref.coupon,
        plan = _ref.plan,
        planVolume = _ref.planVolume,
        upcomingInvoice = _ref.upcomingInvoice;

    if (upcomingInvoice && upcomingInvoice.get('fetching')) return _react2.default.createElement(
        'span',
        null,
        _react2.default.createElement(_Spinner2.default, { show: true })
    );

    var planAmount = (0, _paymentUtil.calculateCouponDiscount)(coupon, plan.get('amount') * planVolume);

    var invoiceAmount = void 0;
    if (upcomingInvoice) {
        invoiceAmount = upcomingInvoice.get('amountDue');
    } else {
        invoiceAmount = planAmount;
    }

    var currency = (0, _currencyUtil.getCurrencySymbol)(plan.get('currency'));

    return _react2.default.createElement(
        'span',
        null,
        currency,
        (0, _paymentUtil.centsToDollars)(invoiceAmount)
    );
};

PaymentAmount.propTypes = {
    coupon: _propTypes2.default.object,
    plan: _propTypes2.default.object,
    planVolume: _propTypes2.default.number,
    upcomingInvoice: _propTypes2.default.object
};

var PaymentSummary = function PaymentSummary(_ref2) {
    var fields = _ref2.fields,
        plans = _ref2.plans,
        planVolume = _ref2.planVolume,
        coupon = _ref2.coupon,
        upcomingInvoice = _ref2.upcomingInvoice;

    if (!plans) return _react2.default.createElement('div', { className: 'PaymentSummary' });

    var selectedPlanValue = (0, _lodash.get)(fields, ['plan', 'value']);
    var plan = plans.filter(function (filterPlan) {
        return filterPlan.get('interval') === selectedPlanValue;
    }).first();

    var couponJs = coupon && coupon.toJS();
    var planAmount = (0, _paymentUtil.calculateCouponDiscount)(couponJs, plan.get('amount') * planVolume);

    var period = plan.get('interval');
    var currency = (0, _currencyUtil.getCurrencySymbol)(plan.get('currency'));

    return _react2.default.createElement(
        'div',
        { className: 'PaymentSummary' },
        _react2.default.createElement(
            'div',
            { className: 'summary' },
            _react2.default.createElement(
                'span',
                null,
                'Billed now'
            ),
            _react2.default.createElement(PaymentAmount, {
                coupon: couponJs,
                plan: plan,
                planVolume: planVolume,
                upcomingInvoice: upcomingInvoice })
        ),
        _react2.default.createElement(
            'div',
            { className: 'disclaimer' },
            'You\'ll be charged ',
            currency,
            (0, _paymentUtil.centsToDollars)(planAmount),
            ' ',
            period,
            'ly (including applicable taxes) until you cancel your subscription. Previous charges won\u2019t be refunded when you cancel unless it\u2019s legally required.'
        )
    );
};

PaymentSummary.propTypes = {
    fields: _propTypes2.default.object,
    plans: _propTypes2.default.object,
    coupon: _propTypes2.default.object,
    upcomingInvoice: _propTypes2.default.object,
    planVolume: _propTypes2.default.number
};

exports.default = PaymentSummary;


//////////////////
// WEBPACK FOOTER
// ./src/client/user/account/payment/form/PaymentSummary.js
// module id = 2061
// module chunks = 0